module.exports = __webpack_public_path__ + "static/media/columns.9c3f1e84.svg";